<template>
  <div>
    <v-app-bar
      dense
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
  
      <v-toolbar-title>{{ $route.meta.title }}</v-toolbar-title> &emsp;
      <v-toolbar-items>
      </v-toolbar-items>
      <v-spacer></v-spacer>
      <div class="summary-report-Category-selection-form" style="Width:250px;">
      <v-select
              :items="availableLocations"
              label="Location:"
              item-text="name"
              item-value="id"
              :dense="true"
              height="20px"
              outlined
              v-model="selectedLocation"
              hide-details
            ></v-select>
      </div>
      Welcome {{ this.userName }}
      
    </v-app-bar>
  
    <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
    >
      <v-list
        nav
        dense
      >
        <v-list-item-group
          v-model="group"
          active-class="blue--text text--accent-4"
        >
          <v-list-item v-for="item in menu" :key="item.href" link :href="item.href">
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
  
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  
  </div>
  </template>
  
  <script>
  import { mapState } from 'vuex'
  export default {
    data() {
      this.userName = localStorage.getItem('username');
      return {
        drawer: false,
        group: null,
        options: [],
        selectedLocation: localStorage.getItem('selectedLocationId') != null ? parseInt(localStorage.getItem('selectedLocationId'))  : 0,
        menu: [
          {
            href: '/',
            title: 'Home',
            icon: 'fa fa-home',
          },
          {
            href: '/ordering',
            title: 'Ordering',
            icon: 'fa fa-file-excel',
          },
          {
            href: '/history',
            title: 'History',
            icon: 'fa fa-history',
          },
          {
            href: '/logout',
            title: 'Logout',
            icon: 'fa fa-sign-out-alt',
          }
        ],
      };
    },
    computed: {
      ...mapState('locations', [
        'availableLocations'
      ])
    },
    created() {
      this.$store.dispatch('locations/getAvailableLocations');
    },
    watch: {
      group () {
        this.drawer = false
      },
      selectedLocation() {
        localStorage.setItem('selectedLocationId', this.selectedLocation);
      },
    },
  };
  
  </script>
  


// WEBPACK FOOTER //
// src/components/Navbar.vue